import { AxiosRequestConfig } from 'axios'
import ResourcesOrigensECPFRepository from 'ecpf/repositories/ResourcesOrigensECPFRepository'

export class ResourceOrigensService {
  async list (path: string, config?: AxiosRequestConfig) {
    return ResourcesOrigensECPFRepository.list(path, config)
  }
}
